import { render, staticRenderFns } from "./GridMixedCol.vue?vue&type=template&id=b0e0bad6"
import script from "./GridMixedCol.vue?vue&type=script&lang=js"
export * from "./GridMixedCol.vue?vue&type=script&lang=js"
import style0 from "./GridMixedCol.vue?vue&type=style&index=0&id=b0e0bad6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports